module.exports = __webpack_public_path__ + "officialStatic/img/detail-one1.a54b339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-one1.png
// module id = C8gK
// module chunks = 0